import { PopOver, Text } from "components/commons";
import { locale } from "localization/en";
import styles from "./detailed-transaction-history-list.module.scss";

const referenceNameOf = (paymentMethod, fallbackRefName) =>
  paymentMethod?.refName || fallbackRefName || "-";

const DetailedTransactionHistoryRefNumbers = ({ paymentMethods, refName }) => {
  const sorted = [...(paymentMethods ?? [])].sort((a, b) => a?.itemId - b?.itemId);

  if (!sorted.length) {
    return <Text className={styles.td}>{"-"}</Text>;
  }

  const [first, ...remaining] = sorted;

  return (
    <>
      <Text className={styles.td}>{first?.refNumber || "-"}</Text>
      <Text className={styles.td}>{referenceNameOf(first, refName)}</Text>
      {remaining.length > 0 && (
        <PopOver
          simple
          content={
            <div className={styles.refNumberList}>
              {remaining.map((paymentMethod, index) => (
                <div key={`ref-${index}`} className={styles.refNumberItem}>
                  <Text className={styles.td}>{paymentMethod?.refNumber || "-"}</Text>
                  <Text className={styles.td}>{referenceNameOf(paymentMethod, refName)}</Text>
                </div>
              ))}
            </div>
          }
        >
          <Text className={styles.viewAll}>{locale.viewAll}</Text>
        </PopOver>
      )}
    </>
  );
};

export default DetailedTransactionHistoryRefNumbers;
